import { useState, useEffect } from 'react';
import { AdminDocument } from '../types';
import { adminDocumentsService } from '../services/admin-documents.service';

export const useAdminDocuments = () => {
  const [documents, setDocuments] = useState<AdminDocument[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadDocuments = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await adminDocumentsService.getAllDocuments();
      setDocuments(data);
    } catch (err: any) {
      setError(err.message || 'Failed to load documents');
    } finally {
      setIsLoading(false);
    }
  };

  const deleteDocument = async (documentId: number) => {
    const success = await adminDocumentsService.deleteDocument(documentId);
    if (success) {
      await loadDocuments();
    }
    return success;
  };

  const downloadDocument = async (documentId: number) => {
    return await adminDocumentsService.downloadDocument(documentId);
  };

  useEffect(() => {
    loadDocuments();
  }, []);

  return {
    documents,
    isLoading,
    error,
    loadDocuments,
    deleteDocument,
    downloadDocument,
  };
};

